<template>
  <div class="card bg-info-soft">
    <div class="card-body">
      <img
        src="@/assets/img/psiapp_plus_logo.png"
        alt=""
        height="30"
        class="mb-3"
      />
      <p class="text-paragraph">
        Quer mais visibilidade para seus pacientes e benefícios pra você?
      </p>
      <button class="btn btn-info" @click="handlePsiappPlus">
        Assinar Psiapp+
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  EOffcanvasViews,
  navigateCanvas,
} from "../OffcanvasViews/OffcanvasViewsConfig";

const handlePsiappPlus = () => {
  navigateCanvas(EOffcanvasViews.subscription);
};
</script>
